import PropTypes from 'prop-types';
import clsx from 'clsx';
import { formatRoomDescription, removeCommissionTerms } from '../../../../helpers/formatters/formatRoomDescription';

const RoomRateDescription = ({
  room,
  doShowRawGDSDescription,
  doShowOriginalShorterRoomDescription,
  doShowAgentCommission,
  doGroupRoomRates,
}) => {
  if (!room) return <></>;
  const category = doShowAgentCommission || !(room.category || '').toLowerCase().includes('commission') ? room.category : undefined;

  return (
    <div className="flex flex-col">
      {doShowRawGDSDescription && (
        <>
          {category ? `${category} - ${room.desc}` : `${room.desc}`}
          {room.type ? ` (${room.type})` : ''}
        </>
      )}
      {!doShowRawGDSDescription && (
        <>
          {!doGroupRoomRates && (
          <div>
            {room.type && `${room.type}`}
            {room.type && room.bedTypes && room.bedTypes.length > 0 ? ' - ' : ''}
            {`${room.bedTypes.join(', ')}`}
            {doShowOriginalShorterRoomDescription && (
            <>
              <br />
                {(() => {
                  const description = room.originalFormattedDesc || room.formattedDesc
                    || formatRoomDescription(room.originalDesc || room.desc);
                  return doShowAgentCommission ? description : removeCommissionTerms(description);
                })()}
            </>
            )}
          </div>
          )}
          {category && (
          <div className={clsx('text-md', { 'text-gray-600': !doGroupRoomRates })}>
            {category}
          </div>
          )}
        </>
      )}
    </div>
  );
};

RoomRateDescription.propTypes = {
  room: PropTypes.shape({
    category: PropTypes.string,
    desc: PropTypes.string.isRequired,
    originalDesc: PropTypes.string,
    formattedDesc: PropTypes.string,
    originalFormattedDesc: PropTypes.string,
    type: PropTypes.string,
    images: PropTypes.arrayOf(PropTypes.shape()),
    bedTypes: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  doShowRawGDSDescription: PropTypes.bool,
  doShowOriginalShorterRoomDescription: PropTypes.bool,
  doShowAgentCommission: PropTypes.bool,
  doGroupRoomRates: PropTypes.bool,
};

RoomRateDescription.defaultProps = {
  doShowRawGDSDescription: true,
  doShowOriginalShorterRoomDescription: false,
  doShowAgentCommission: true,
  doGroupRoomRates: false,
};

export default RoomRateDescription;
